module.exports = __webpack_public_path__ + "static/pew-religion-africa-570b6c5f9a5413f00676184c712c6132.png";